import Cookies from 'js-cookie'
import jstz from 'jstz'

export function findTimeZone() {
  const oldIntl = window.Intl
  try {
    window.Intl = undefined
    const tz = jstz.determine().name()
    window.Intl = oldIntl
    return formatTimeZone(tz)
  } catch (e) {
    // sometimes (on android) you can't override intl
    return formatTimeZone(jstz.determine().name())
  }
}

function formatTimeZone(timeZone) {
  const parts = timeZone.split('/')
  return parts.length > 1 ? parts[1].replace(/_/g, ' ') : timeZone
}

document.addEventListener("turbo:load", () => {
  const fullTimezoneName = jstz.determine().name()
  const formattedTimezoneName = findTimeZone()
  
  console.log("Setting browser time zone to: ", formattedTimezoneName, "(", fullTimezoneName, ")")
  
  // Store both the full timezone identifier and the formatted name
  Cookies.set("browser_time_zone", formattedTimezoneName, { expires: 365, path: "/", secure: true, sameSite: 'strict' })
  Cookies.set("browser_time_zone_full", fullTimezoneName, { expires: 365, path: "/", secure: true, sameSite: 'strict' })
})
